/**
 * Created by User on 18/04/2016.
 */
import Utils from './Utils';

export default VAST3ErrorTracker;

function VAST3ErrorTracker() {

}

VAST3ErrorTracker.initialize = function(urls) {
  VAST3ErrorTracker._errorURLs = urls;
};

VAST3ErrorTracker.track = function(code) {
  if (VAST3ErrorTracker._errorURLs && VAST3ErrorTracker._errorURLs.length) {
    var url;
    for (var i = 0, l = VAST3ErrorTracker._errorURLs.length; i < l; ++i) {
      url = VAST3ErrorTracker._errorURLs[i];
      while (url.indexOf('[ERRORCODE]') != -1) {
        url = url.replace('[ERRORCODE]', code);
      }
      if (Utils.isStringWithData(url)) {
        // loader = new Loader();
        // loader.load(url);
        if (url.length > 5) {
          var img = document.createElement('img');
          img.src = url;
        }
      }
    }
  }
};

VAST3ErrorTracker.reset = function() {
  VAST3ErrorTracker._errorURLs = null;
};

VAST3ErrorTracker._errorURLs = null;